import NumberBullet from './NumberBullet';

export default NumberBullet;